import { useContext } from 'react';
import { Menu } from '@headlessui/react';
import { HiDotsHorizontal } from "react-icons/hi";
import { Link } from 'react-router-dom';
import { RiEyeLine } from 'react-icons/ri';
import { LuFileBadge, LuTrash } from 'react-icons/lu';
import { EntityContext } from '../../context/EntityContext';
import { IoIosLink } from 'react-icons/io';
import { MdOutlineShoppingCart } from 'react-icons/md';
import { GoDownload } from "react-icons/go";
import { GoUpload } from "react-icons/go";
import {S3PlanFileDownloader} from "../../helper/s3ClientHandler";


const MenuItem = ({ to, onClick, icon: Icon, title, text, className }) => (
  <Menu.Item>
    {to ? (
      <Link to={to} className={`flex p-2 hover:bg-gray-900 hover:text-white ${className}`} onClick={onClick}>
        <Icon title={title} className="w-8 h-8 p-2" />
        <span className="h-8 p-2">{text}</span>
      </Link>
    ) : (
      <div className={`flex p-2 hover:bg-gray-900 hover:text-white ${className}`} onClick={onClick}>
        <Icon title={title} className="w-8 h-8 p-2" />
        <span className="h-8 p-2">{text}</span>
      </div>
    )}
  </Menu.Item>
);

const renderMenuItem = (condition, props) => condition && <MenuItem {...props} />;


export default function CardDetailsMenu() {
  const {
    setCurrentEntity,
    setOpenDeleteModal,
    setOpenShareMapsLink,
    setOpenPlanToOrderModal,
    setOpenPlanRefModal,
    orders,
    currentSetting,
  } = useContext(EntityContext);

  return (
    <Menu as="div" className="relative text-sm inline-block text-left">
      <div>
        <Menu.Button className="inline-flex w-full items-center justify-center rounded-md bg-white px-3 py-2 text-sm text-gray-600 justify-items-center   hover:bg-gray-50">
          <HiDotsHorizontal className={"h-5 w-5"} />
        </Menu.Button>
      </div>

      <Menu.Items
        transition="true"
        className="absolute right-0 z-10 mt-2 w-56  origin-top-right divide-y divide-gray-500 rounded-md bg-white shadow-lg ring-1 ring-gray-500 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div className={"cursor-pointer"}>
          {renderMenuItem(currentSetting?.actions?.planOrderChange, {
            onClick: () => {
              setCurrentEntity(orders);
              setOpenPlanToOrderModal(true);
            },
            icon: MdOutlineShoppingCart,
            title: 'Änderung beauftragen',
            text: 'Änderung beauftragen',
          })}
        </div>
        <div>

          {renderMenuItem(currentSetting?.actions?.orderOpen, {
            to: `/order/${orders?.id}`,
            icon: RiEyeLine,
            title: 'Auftrag öffnen',
            text: 'Auftrag anzeigen',
          })}

          {renderMenuItem(currentSetting?.actions?.planLinkViewer, {
            to: `/viewer/${orders?.id}`,
            icon: RiEyeLine,
            title: 'XPlan im Viewer anzeigen',
            text: 'Plan anzeigen',
          })}
          {renderMenuItem(currentSetting?.actions?.refUpload, {
            onClick: () => {
              setCurrentEntity(orders);
              setOpenPlanRefModal(true);
            },
            icon: GoUpload,
            title: 'Referenzen hinterlegen',
            text: 'Referenzen hinterlegen',
          })}

          {renderMenuItem(currentSetting?.actions?.planDownload, {
            onClick: () => S3PlanFileDownloader(orders),
            icon: GoDownload ,
            title: 'Plan herunterladen',
            text: 'Plan herunterladen',
          })}

          {renderMenuItem(currentSetting?.actions?.planCertificatedCreate, {
            to: `/plan/${orders?.id}/certificate`,
            icon: LuFileBadge,
            title: 'Zertifikat anzeigen',
            text: 'Zertifikat anzeigen',
          })}

          {renderMenuItem(currentSetting?.actions?.mapLinkViewer, {
            to: `/maps/${orders?.id}`,
            icon: RiEyeLine,
            title: 'Karte anzeigen',
            text: 'Karte anzeigen',
          })}

          {renderMenuItem(currentSetting?.actions?.mapLinkCopy, {
            onClick: () => {
              setCurrentEntity(orders);
              setOpenShareMapsLink(true);
            },
            icon: IoIosLink,
            title: 'Link teilen',
            text: 'Link teilen',
          })}
        </div>
        <div>
          {renderMenuItem(currentSetting?.actions?.planDelete, {
            onClick: () => {
              setCurrentEntity(orders);
              setOpenDeleteModal(true);
            },
            icon: LuTrash,
            title: 'Plan löschen',
            text: 'Plan löschen',
            className: 'text-red cursor-pointer hover:bg-red hover:text-white',
          })}

          {renderMenuItem(currentSetting?.actions?.mapDelete, {
            onClick: () => {
              setCurrentEntity(orders);
              setOpenDeleteModal(true);
            },
            icon: LuTrash,
            title: 'Karte löschen',
            text: 'Karte löschen',
            className: 'text-red cursor-pointer hover:bg-red hover:text-white',
          })}

          {(orders.stage === 'draft') ? (
              renderMenuItem(currentSetting?.actions?.orderDelete, {
              onClick: () => {
                setCurrentEntity(orders);
                setOpenDeleteModal(true);
              },
              icon: LuTrash,
              title: 'Auftrag löschen',
              text: 'Auftrag löschen',
              className: orders.stage === 'draft' ? 'text-red cursor-pointer hover:bg-red hover:text-white' : 'text-gray-600 cursor-not-allowed hover:bg-gray-300',
            })
          ) : ("")}
        </div>
      </Menu.Items>
    </Menu>
  );
}
